import I18n from 'I18n';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { Small } from 'foundations-components/transitional/components/Small';
import styled from 'foundations-theming/utils';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { createProductConfig } from 'pricing-pages-lib/utils/productConfigUtils';
import { getOnboardingServicesUrlPublic } from 'pricing-pages-lib/utils/publicPageUrls';
import { CrossedOutPrice, PriceDisplay } from 'pricing-pages-ui-components/price/PriceDisplay';
import { HUBSPOT_FOR_STARTUPS_SETUP } from 'self-service-api/constants/ApiNames';
import { usePurchaseOptionsForProductsForTerm } from '../../hooks/usePurchaseOptions';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BringAttention = styled.b.withConfig({
  displayName: "RequiredOnboardingSubtext__BringAttention",
  componentId: "n834fw-0"
})([""]);
const RequiredOnboardingSubtext = ({
  skuIds,
  langKey,
  currencyCode,
  tab,
  trackingSource,
  includesOnboardingCost
}) => {
  const onboardingServicesUrl = getOnboardingServicesUrlPublic(HUBSPOT_FOR_STARTUPS_SETUP === langKey);
  const handleClick = () => {
    trackClickedLink({
      name: 'onboarding-services',
      value: getI18nText('planBuilder.requiredOnboardingSubtext.learnMore', {
        locale: 'en-us'
      }),
      type: 'external',
      url: onboardingServicesUrl,
      tab,
      trackingSource
    });
  };
  const onboardingIncludedKey = includesOnboardingCost ? 'onboardingIncluded' : 'onboardingNotIncluded';
  const productConfigurations = skuIds.map(skuId => createProductConfig({
    quantity: 1,
    skuId
  }));
  const {
    pricingData: pricingInfo
  } = usePurchaseOptionsForProductsForTerm({
    productConfigurations
  });
  if (!(pricingInfo !== null && pricingInfo !== void 0 && pricingInfo.oneTimeFee)) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Small, {
    children: [pricingInfo.monthly.fullPrice > pricingInfo.monthly.calculatedPrice ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}-with-discount_jsx`,
      options: {
        currencyCode,
        fullPrice: pricingInfo.oneTimeFee.fullPrice,
        discountedPrice: pricingInfo.oneTimeFee.calculatedPrice
      },
      elements: {
        PriceDisplay,
        CrossedOutPrice,
        b: BringAttention
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.requiredOnboardingSubtext.${onboardingIncludedKey}.${langKey}_jsx`,
      options: {
        currencyCode,
        price: pricingInfo.oneTimeFee.calculatedPrice
      },
      elements: {
        PriceDisplay,
        b: BringAttention
      }
    }), ' ', /*#__PURE__*/_jsx(Link, {
      external: true,
      onClick: handleClick,
      href: onboardingServicesUrl,
      "aria-label": I18n.text(`planBuilder.requiredOnboardingSubtext.onboarding.${langKey}`),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.requiredOnboardingSubtext.learnMore"
      })
    })]
  });
};
export default RequiredOnboardingSubtext;